/**
 * Rechtstexte — Platzhalter für späteren öffentlichen Betrieb.
 * Vor Live-Gang: Angaben durch Betreiber/Rechtsberatung ersetzen.
 */

export const LEGAL_META = {
  productName: "BOS Dispatch Architect",
  shortName: "BDA",
  contactEmail: "[E-MAIL EINTRAGEN]",
  operatorName: "[NAME / FIRMA EINTRAGEN]",
  operatorAddress: "[STRASSE, PLZ ORT EINTRAGEN]",
  lastUpdated: "2026-08-21",
};

export type LegalDocId = "impressum" | "privacy" | "terms" | "youth";

export const LEGAL_DOCS: Array<{
  id: LegalDocId;
  title: string;
  body: string[];
}> = [
  {
    id: "impressum",
    title: "Impressum",
    body: [
      `Angaben gemäß § 5 TMG (Platzhalter)`,
      `${LEGAL_META.operatorName}`,
      LEGAL_META.operatorAddress,
      `Kontakt: ${LEGAL_META.contactEmail}`,
      `Produkt: ${LEGAL_META.productName} (${LEGAL_META.shortName})`,
      "Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV: [NAME EINTRAGEN]",
      "Aktuell: geschlossene Testphase (Dev), typischerweise erreichbar über Server-IP ohne öffentliche Domain. Kein Angebot an die Allgemeinheit bis zur Freigabe.",
      `Stand: ${LEGAL_META.lastUpdated}`,
    ],
  },
  {
    id: "privacy",
    title: "Datenschutz",
    body: [
      "1. Verantwortlicher",
      `${LEGAL_META.operatorName}, ${LEGAL_META.operatorAddress}, ${LEGAL_META.contactEmail}`,
      "2. Verarbeitete Daten (Testphase / Dev)",
      "E-Mail-Adresse, Benutzername, Passwort-Hash (scrypt), Freigabe-/Admin-Status, Zeitpunkt der AGB-Zustimmung, Spielstand (Welt, Gebäude, Fahrzeuge, Einsätze) in der betriebenen SQLite-Datenbank. Optional: Kartendaten von Drittanbietern (OpenStreetMap / Nominatim / OSRM / Kachelserver) — deren Datenschutzbestimmungen gelten zusätzlich.",
      "3. Zweck",
      "Authentifizierung, Testzugang (Freigabe durch Admin), Bereitstellung des Spiels, Speicherung des Spielstands, Missbrauchsprävention.",
      "4. Rechtsgrundlage",
      "Soweit DSGVO anwendbar: Art. 6 Abs. 1 lit. b (Nutzungsverhältnis / Spielbetrieb) und lit. f (berechtigtes Interesse an stabilem, geschlossenem Testbetrieb). Einwilligung zur Registrierung über Opt-in (AGB/Datenschutz-Checkbox). Platzhalter — vor öffentlichem Live-Gang prüfen/anpassen.",
      "5. Speicherdauer",
      "Konten und Welten bis zur Löschung durch Nutzer oder Betreiber. Testaccounts können ohne Vorankündigung gelöscht/zurückgesetzt werden.",
      "6. Rechte der Betroffenen",
      "Auskunft, Berichtigung, Löschung, Einschränkung, Widerspruch, Datenübertragbarkeit — Kontakt siehe oben. Beschwerde bei einer Aufsichtsbehörde möglich.",
      "7. Cookies / lokale Speicherung",
      "Die Web-App speichert lokal u. a. Auth-Token, Theme und Audio-Einstellungen im Browser (localStorage). Keine Tracking-Cookies / kein Werbe-Tracking in der aktuellen Version.",
      "8. Weitergabe",
      "Keine Weitergabe zu Werbezwecken. Hosting/Karten-APIs nur soweit für den Betrieb nötig.",
      "9. Testphase",
      "Die Anwendung läuft in einer geschlossenen Dev-/Testphase. Eine öffentliche Bewerbung oder Massenregistrierung ist nicht beabsichtigt, bis der Betreiber den Betrieb freigibt.",
      `Stand: ${LEGAL_META.lastUpdated}`,
    ],
  },
  {
    id: "terms",
    title: "Nutzungsbedingungen (AGB)",
    body: [
      `§ 1 Geltungsbereich — Diese Bedingungen gelten für die Nutzung von ${LEGAL_META.productName} in der Testphase.`,
      "§ 2 Leistungsbeschreibung — Browserbasiertes Management-Spiel (Simulation). Kein realer Notruf, keine echte Leitstellen-Software, keine verbindliche Ausbildung.",
      "§ 3 Account — Registrierung mit E-Mail und Benutzername. Passwort geheim halten. Der Betreiber kann Spielzugang freigeben oder sperren (Dev-Freigabe). Admin-Accounts dienen der Verwaltung.",
      "§ 4 Spielstände — In der Testphase gilt in der Regel ein Spielstand pro Account. Speichern/Reset kann Daten löschen. Keine Garantie auf dauerhafte Persistenz.",
      "§ 5 Spielregeln / Fairness — Cheating, Störung des Betriebs und rechtswidrige Inhalte sind untersagt.",
      "§ 6 Inhalte Dritter — Kartendaten und POIs können von OpenStreetMap und anderen Diensten stammen.",
      "§ 7 Verfügbarkeit — Alpha/Beta/Dev ohne Garantie. Deployments können Spielstände oder Katalog-Overrides betreffen; Admin-Edits am Einsatzkatalog werden in der Datenbank gehalten, sofern nicht bewusst überschrieben.",
      "§ 8 Haftung — Haftung nur nach gesetzlich zwingenden Vorschriften. Keine Haftung für Spielspaß, Spielstände oder mittelbare Schäden, soweit gesetzlich zulässig.",
      "§ 9 Jugendschutz — Siehe gesonderter Hinweis. Empfohlen ab 12 Jahren (Platzhalter).",
      "§ 10 Änderungen — Bedingungen können angepasst werden; wesentliche Änderungen werden in der App hingewiesen.",
      "§ 11 Schlussbestimmungen — Recht der Bundesrepublik Deutschland, soweit zulässig.",
      `Stand: ${LEGAL_META.lastUpdated}`,
    ],
  },
  {
    id: "youth",
    title: "Jugendschutz & Hinweis",
    body: [
      "Dieses Spiel thematisiert Rettungsdienste, Polizei und Feuerwehr in einer fiktiven Simulation.",
      "Es ersetzt keinen Notruf (112 / 110). Bei echten Notfällen immer die offiziellen Notrufnummern wählen.",
      "Empfohlenes Mindestalter: 12 Jahre (Platzhalter — vor Veröffentlichung prüfen).",
      "Gewalt wird nicht grafisch ausgespielt; Einsätze sind abstrakt (Kartenmarker, Status, Disposition).",
    ],
  },
];
